import React from "react";
import { Button, SelectBox, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import { DataMap, dataSources, enums, User } from "../../base";
import { BottleBatchModel, BottleModel } from "../../models";
import { ValueChangedEvent } from "devextreme/ui/select_box";

const bottleStatusList: String[] = [
    "正常", "过期", "报废"
]

export interface BottleToolbarProps {
    permissions: DataMap<boolean>;
    user?: User;
    onButtonClick: (model: BottleModel, name: string) => void;
    onBatchButtonClick: (models: BottleBatchModel[], name: string) => void;
    onFiltering: (filterValue: any[], isPorcelainCode?: boolean) => void;
}

interface BottleToolbarState {
    isPorcelainCode?: boolean;
    status?: string;
    deleted?: boolean;
    model: BottleModel;
    batchModels: BottleBatchModel[];
}

export default class BottleToolbar extends React.Component<BottleToolbarProps, BottleToolbarState> {
    constructor(props: Readonly<BottleToolbarProps>) {
        super(props);

        this.state = {
            model: {},
            batchModels: []
        };

        this.onPorcelainCodeChanged = this.onPorcelainCodeChanged.bind(this);
        this.onStatusChanged = this.onStatusChanged.bind(this);
        this.onDeletedChanged = this.onDeletedChanged.bind(this);
        this.onFiltering = this.onFiltering.bind(this);
    }

    setModel(model: BottleModel) {
        this.setState({ model: model });
    }

    setBatchModels(models: BottleBatchModel[]) {
        this.setState({ batchModels: models });
    }

    onPorcelainCodeChanged(event: ValueChangedEvent) {
        this.setState({ isPorcelainCode: event.value });
    }

    onStatusChanged(event: ValueChangedEvent) {
        this.setState({ status: event.value });
    }

    onDeletedChanged(event: ValueChangedEvent) {
        this.setState({ deleted: event.value });
    }

    onFiltering() {
        const { isPorcelainCode, status, deleted } = this.state;
        const filterValue: any[] = [];

        if (status) {
            filterValue.push(["status", "=", status]);
        }

        if (typeof (deleted) === "boolean") {
            filterValue.push(["deleted", "=", deleted]);
        }

        this.props.onFiltering(filterValue, isPorcelainCode);
    }

    render() {
        const { user, onButtonClick, onBatchButtonClick } = this.props;
        const { model, batchModels, isPorcelainCode, status, deleted } = this.state;

        const batchModel0 = batchModels[0];
        const deleteButtonText = batchModel0?.deleted ? "恢复" : "注销";
        const deleteButtonEnabled = batchModels.length > 0 && !batchModels.find(m => m.deleted !== batchModel0.deleted);

        return (
            <div className={"page-toolbar"}>
                <Toolbar>
                    <Item location={"before"} locateInMenu={"auto"}>
                        <SelectBox
                            dataSource={dataSources.trueFalseList}
                            displayExpr={"text"}
                            valueExpr={"value"}
                            value={isPorcelainCode}
                            showClearButton={true}
                            placeholder="是否陶瓷码"
                            onValueChanged={this.onPorcelainCodeChanged} />
                    </Item>
                    <Item location={"before"} locateInMenu={"auto"}>
                        <SelectBox
                            dataSource={bottleStatusList}
                            value={status}
                            showClearButton={true}
                            placeholder="状态"
                            onValueChanged={this.onStatusChanged} />
                    </Item>
                    <Item location={"before"} locateInMenu={"auto"}>
                        <SelectBox
                            dataSource={dataSources.trueFalseList}
                            displayExpr={"text"}
                            valueExpr={"value"}
                            value={deleted}
                            showClearButton={true}
                            placeholder="是否已注销"
                            onValueChanged={this.onDeletedChanged} />
                    </Item>
                    <Item location={"before"} locateInMenu="auto">
                        <Button
                            text="查询"
                            type="default"
                            onClick={this.onFiltering} />
                    </Item>
                    {user?.isAdmin && (
                        <Item location={"after"} locateInMenu={"auto"}>
                            <Button
                                text="新增"
                                onClick={() => onButtonClick({}, "add")} />
                        </Item>
                    )}
                    {user?.isAdmin && (
                        <Item location={"after"} locateInMenu="auto">
                            <Button
                                disabled={!model?.id}
                                text="编辑"
                                onClick={() => onButtonClick(model, "edit")} />
                        </Item>
                    )}
                    {this.props.permissions[enums.stdActions.delete] && (
                        <Item location={"after"} locateInMenu={"auto"}>
                            <Button
                                disabled={!deleteButtonEnabled}
                                text={deleteButtonText}
                                onClick={() => onBatchButtonClick(batchModels, "del")} />
                        </Item>
                    )}
                    {this.props.permissions[enums.stdActions.delete] && (
                        <Item location={"after"} locateInMenu={"auto"}>
                            <Button
                                text="导入已注销气瓶"
                                onClick={() => onButtonClick(model, "importdeleted")} />
                        </Item>
                    )}
                </Toolbar>
            </div>
        );
    }
}